var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        "show-close": false,
        visible: _vm.visible,
        "destroy-on-close": "",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.visible = $event
        }
      }
    },
    [
      _c("div", { staticStyle: { padding: "15px" } }, [
        _c(
          "p",
          {
            staticClass: "back_icon",
            on: {
              click: function($event) {
                _vm.visible = false
              }
            }
          },
          [
            _c("i", { staticClass: "el-icon-arrow-left" }),
            _vm._v("Edit Variant")
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "title" }, [
          _c("div", [_vm._v("Action")]),
          _vm._v(" "),
          _c("div", [_vm._v("Options name*")]),
          _vm._v(" "),
          _c("div", [_vm._v("Opitons value*")])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { attrs: { id: "character" } },
          _vm._l(_vm.variantArr, function(itm, i) {
            return _c(
              "div",
              { key: i, staticClass: "content", attrs: { "data-id": i } },
              [
                _c("div", { staticClass: "el-icon-more" }),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c(
                      "el-select",
                      {
                        ref: "createSelect",
                        refInFor: true,
                        attrs: {
                          filterable: "",
                          "allow-create": "",
                          "default-first-option": "",
                          remote: "",
                          "remote-method": function(e) {
                            return _vm.checkOptionNameRepeat(e, itm)
                          },
                          placeholder: "Select"
                        },
                        on: {
                          change: function(e) {
                            return _vm.changeVariant(e, itm)
                          }
                        },
                        model: {
                          value: itm["variantName"],
                          callback: function($$v) {
                            _vm.$set(itm, "variantName", $$v)
                          },
                          expression: "itm['variantName']"
                        }
                      },
                      _vm._l(itm["variantNameArr"], function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    ),
                    _vm._v(" "),
                    itm["isRepeat"] && itm["variantName"]
                      ? _c("div", [
                          _vm._v(
                            "You've already used the option name \"" +
                              _vm._s(itm["repeatValue"]) +
                              '"'
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    !itm["variantName"]
                      ? _c("div", [_vm._v("Please select an option.")])
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c("input-tag", {
                  ref: "input-tag",
                  refInFor: true,
                  attrs: {
                    "index-str": itm["variantName"],
                    repeatMsg: "You’ve already used the option value “{tag}”",
                    placeholder: "Type an options and press enter…",
                    "delete-confirm-msg": itm["confirmMsg"],
                    tags: itm["tagArr"]
                  },
                  on: { getTags: _vm.getTags }
                }),
                _vm._v(" "),
                _c("div", {
                  staticClass: "el-icon-delete",
                  on: {
                    click: function($event) {
                      return _vm.removeRow(i, itm)
                    }
                  }
                })
              ],
              1
            )
          }),
          0
        ),
        _vm._v(" "),
        _vm.isShowAddOption
          ? _c("div", { staticClass: "add-option" }, [
              _c("span", { on: { click: _vm.addMoreOption } }, [
                _c("i", { staticClass: "el-icon-plus" }),
                _vm._v(" Add another option")
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "submit-info" }, [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isError,
                  expression: "isError"
                }
              ]
            },
            [_vm._v(_vm._s(_vm.sumbitErrorMsg))]
          ),
          _vm._v(" "),
          _c("div", { on: { click: _vm.submit } }, [_vm._v("Save Options")])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-93d84398", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-93d84398","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/spuDetails/sku-variant.vue
// module id = vLHY
// module chunks = 2